<template>
  <div style="display: inline-block; position: relative">
    <!-- <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown"  transfer-class-name='myDropDown'>
      <div style="display: inline-block">
        <div class="header-right-icon header-user header-action" style="padding-right:20px" :title='nickname'>
          <div v-if="avatar" class="avatar">{{ wordAvatar}}</div>
          <Avatar v-else :src="avatar" size="small"></Avatar>
          <span class="header-username">{{ nickname }}</span>
        </div>
      </div>
      <DropdownMenu slot="list">
        <DropdownItem class='msg'>
          <div  class="avatar">{{ wordAvatar}}</div>
          <div class="name">
            <div class="personName">
              <div>{{nickname}}</div>
              <div>管理员</div>
            </div>
            <div class="placeName">中山欢乐海岸</div>
          </div>
          </DropdownItem
        >
        <DropdownItem name="ownSpace">
          <Icon type="md-person" style="margin: 0 10px 0 0" />{{
            $t("userCenter")
          }}</DropdownItem
        >
         <DropdownItem >
          <Icon type="ios-phone-portrait" style="margin: 0 10px 0 0"  />{{
            手机号码
          }}</DropdownItem
        >
        <DropdownItem name="changePass">
          <Icon type="md-unlock" style="margin: 0 10px 0 0" />{{
            $t("changePass")
          }}</DropdownItem
        >
        <DropdownItem name="showAbout">
          <Icon type="md-videocam" style="margin: 0 10px 0 0" />
            关于
          </DropdownItem
        >
        <DropdownItem name="loginout" divided>
          <Icon type="md-log-out" style="margin: 0 10px 0 0" />{{
            $t("logout")
          }}</DropdownItem
        >
      </DropdownMenu>
    </Dropdown> -->

    <Dropdown transfer trigger="hover" @on-click="handleClickUserDropdown">
      <Avatar
        v-if="avatar && avatar != '/defaultAvatar.png'"
        :src="avatar"
        size="small"
        :title="nickname"
        class="avatar"
      ></Avatar>
      <div v-else class="avatar" :title="nickname">{{ wordAvatar }}</div>
      <Dropdown-menu slot="list" style="width: 230px" class="myDropdown">
        <Dropdown-item class="msg" name="ownSpace">
          <Avatar
            v-if="avatar && avatar != '/defaultAvatar.png'"
            :src="avatar"
            size="small"
            :title="nickname"
            class="avatar"
          ></Avatar>
          <div v-else class="avatar" :title="nickname">{{ wordAvatar }}</div>
          <div class="name">
            <div
              :class="[roles == 'ROLE_ADMIN' ? 'personName2' : 'personName1']"
            >
              <div>{{ nickname }}</div>
              <div>
                {{ roles == "ROLE_ADMIN" ? "管理员" : "" }}
              </div>
            </div>
            <div class="placeName" v-if="tenantOrgId == 'DEFAULT'">
              {{ departmentTitle === undefined ? "无" : departmentTitle }}
            </div>
            <div class="placeName" v-else>
              {{ sysName === undefined ? "智慧物联平台" : sysName }}
            </div>
          </div>
        </Dropdown-item>
        <Dropdown-item class="phoneNum">
          <Icon type="md-phone-portrait" size="20" />
          <div style="margin: 0 16px 0 10px">手机号码</div>
          <div style="font-weight: 700"></div>
          {{
            phoneNum === undefined
              ? "无"
              : phoneNum.toString().slice(0, 3) +
                "****" +
                phoneNum.toString().slice(-4)
          }}
          <div class="edit" @click="phoneChange">
            <Icon type="md-create" size="14" color="#307aea" />
          </div>
        </Dropdown-item>
        <Dropdown-item name="changePass">
          <Icon type="md-lock" size="20" />
          <div style="margin: 0 16px 0 10px">密码修改</div>
        </Dropdown-item>
        <Dropdown-item style="margin-bottom: 0" name="loginout">
          <Icon type="md-exit" size="20" />
          <div style="margin: 0 16px 0 10px">退出登录</div>
        </Dropdown-item>
      </Dropdown-menu>
    </Dropdown>

    <!-- 弹窗 -->
    <!-- 更换手机号 -->
    <Modal
      v-model="isWindowChange1"
      class-name="windowChange1"
      width="430"
      :title="windowText1"
      @on-cancel="dataEmpty"
      footer-hide
    >
      <div @click="isFocus">
        <div class="text" v-show="passwordChangeStep != 3">
          你正在修改{{
            passwordChangeStep == 4 ? "密码" : "登录手机号"
          }}，请先完成身份验证。验证码已发送至<br />
          <span style="color: #307aea; padding-left: 0; font-size: 18px"
            >+86
            {{
              phoneNum === undefined
                ? "无"
                : phoneNum.toString().slice(0, 3) +
                  "****" +
                  phoneNum.toString().slice(-4)
            }}</span
          >
          短信有效期<span>10</span>分钟。
        </div>
        <div class="text" v-show="passwordChangeStep == 3">
          请输入发送至
          <span style="color: #307aea; font-size: 18px"
            >+86
            {{
              phoneNum === undefined
                ? "无"
                : phoneNum.toString().slice(0, 3) +
                  "****" +
                  phoneNum.toString().slice(-4)
            }}</span
          >
          的6位验证码,有效期<br /><span style="padding-left: 0">10</span>分钟。
        </div>
        <template>
          <input
            type="text"
            v-model="codeNum"
            maxlength="6"
            class="myInput"
            @blur="showFocus = false"
          />
          <!-- style="display: none" -->
          <div class="codeNum" @click="codeFocus">
            <div class="showCode">
              <div
                :class="codeNum.length == 0 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[0] }}
            </div>
            <div class="showCode">
              <div
                :class="codeNum.length == 1 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[1] }}
            </div>
            <div class="showCode">
              <div
                :class="codeNum.length == 2 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[2] }}
            </div>
            <div class="showCode">
              <div
                :class="codeNum.length == 3 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[3] }}
            </div>
            <div class="showCode">
              <div
                :class="codeNum.length == 4 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[4] }}
            </div>
            <div class="showCode">
              <div
                :class="codeNum.length == 5 && showFocus ? 'focus' : ''"
              ></div>
              {{ codeNum[5] }}
            </div>
          </div>
        </template>
        <div
          v-show="reGetCodeTime > 0 && reGetCodeTime < 60"
          class="reGetCode"
          style="color: #ccc"
        >
          {{ reGetCodeTime }}秒后可重新获取验证码
        </div>
        <div
          v-show="reGetCodeTime == 60"
          class="getCode"
          style="color: #307aea; cursor: pointer"
          @click="getPhoneNum('old')"
        >
          点击获取验证码
        </div>
        <div
          style="
            color: #307aea;
            font-size: 12px;
            margin-top: 10px;
            cursor: pointer;
          "
          @click="isError('请联系管理员修改手机号')"
          v-show="passwordChangeStep != 3"
        >
          手机已停用?
        </div>
      </div>
    </Modal>
    <Modal
      v-model="isWindowChange2"
      class-name="windowChange2"
      width="320"
      :title="windowText2"
      @on-cancel="dataEmpty"
      footer-hide
    >
      <template v-if="!showChangePass">
        <Form
          :model="changeWindow2Form"
          :rules="changeWindow2FormValidate"
          style="height: 120px"
          ref="form2"
        >
          <FormItem prop="phoneNum" class="phoneNum">
            <Input
              v-model="changeWindow2Form.phone"
              :maxlength="11"
              placeholder="请输入手机号"
            />
          </FormItem>
          <FormItem prop="code" class="code">
            <Input
              v-model="changeWindow2Form.code"
              :maxlength="20"
              placeholder="请输入6位验证码"
            />
            <Button
              @click="getPhoneNum('new')"
              :class="[
                getCodeTimer || changeWindow2Form.phone.length != 11
                  ? 'btn_no'
                  : 'btn_ok',
              ]"
              style="width: 190px; height: 36px; margin-left: 10px"
              >{{
                getCodeTimer == null ? "获取验证码" : `${getCodeTime}秒后重发`
              }}</Button
            >
          </FormItem>
        </Form>
        <Button
          @click="savePhoneNum"
          :class="[isSave ? 'btn_ok' : 'btn_no']"
          style="height: 36px; width: 100%"
          >保存</Button
        >
      </template>
      <!-- 修改密码 -->
      <template v-else-if="showChangePass && passwordChangeStep == 1">
        <div style="color: #aaa; margin-bottom: 10px">
          为了你的账号安全,请先验证旧密码。
        </div>
        <Input
          v-model="passwordOld"
          type="password"
          password
          placeholder="请输入密码"
          style="height: 36px; margin-bottom: 10px"
        />
        <div style="margin-bottom: 16px; color: #aaa">
          忘记了密码?<span
            style="color: #307aea; cursor: pointer"
            @click="resetPassWord"
            >点击重置</span
          >
        </div>
        <Button
          @click="changePassword(2)"
          :class="[passwordOld == '' ? 'btn_no' : 'btn_ok']"
          style="height: 36px; width: 100%"
          >下一步</Button
        >
      </template>
      <template v-else-if="showChangePass && passwordChangeStep == 2">
        <Input
          v-model="passwordNew.one"
          type="password"
          password
          placeholder="请输入新密码"
          style="height: 36px; margin-bottom: 10px"
        />
        <Input
          v-model="passwordNew.two"
          type="password"
          password
          placeholder="请重复输入新密码"
          style="height: 36px; margin-bottom: 10px"
        />
        <div style="color: #aaa; margin-bottom: 10px">
          密码要求:含英文和数字,6~12位。
        </div>
        <Button
          @click="changePassword(3)"
          :class="[
            passwordNew.one == '' || passwordNew.two == ''
              ? 'btn_no'
              : 'btn_ok',
          ]"
          style="height: 36px; width: 100%"
          >下一步</Button
        >
      </template>
    </Modal>
    <!-- 修改密码 -->
    <!-- <changePass v-model="showChangePass" /> -->
    <!-- <about v-model="showAbout" /> -->
    <Modal
      v-model="showMsgTip"
      class-name="showMsgTip"
      width="320"
      @on-cancel="dataEmpty"
      footer-hide
    >
      <div
        :class="[
          showMsgNum == 1
            ? 'imgBox img1'
            : showMsgNum == 2
            ? 'imgBox img2'
            : 'imgBox img3',
        ]"
      ></div>
      <div class="text1">
        {{
          showMsgNum == 1
            ? "错误次数过多"
            : showMsgNum == 2
            ? "密码修改成功！"
            : "手机号修改成功！"
        }}
      </div>
      <div class="text2">
        {{
          showMsgNum == 1
            ? errMessage
            : showMsgNum == 2
            ? "密码修改成功，以后请使用新密码登录"
            : "手机号修改成功，以后请使用新手机号登录"
        }}
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getOtherSet,
  modifyPassword,
  checkOldPassword,
  modifyPhone,
  checkMessageCode,
  sendMessageCode,
  getAllThemeSetting,
} from "@/api/index";
import util from "@/libs/util.js";
// import changePass from "@/views/change-pass/change-pass";
// import about from "@/views/about/about";
import Cookies from "js-cookie";

export default {
  name: "user",
  components: {
    // changePass,
    // about,
  },
  props: {},
  computed: {
    nickname() {
      return this.$store.state.user.nickname;
    },
    avatar() {
      return this.$store.state.user.avatar;
    },
    sysName() {
      return this.$store.state.theme.theme.sysName;
    },
    userId() {
      return JSON.parse(localStorage.userInfo).id;
    },
    departmentTitle() {
      return JSON.parse(localStorage.userInfo).departmentTitle;
    },
    updateByName() {
      return JSON.parse(localStorage.userInfo).updateByName;
    },
    tenantOrgId() {
      return JSON.parse(localStorage.userInfo).tenantOrgId;
    },
    type() {
      return JSON.parse(localStorage.userInfo).type;
    },
    roles() {
      return JSON.parse(localStorage.roles)[0];
    },
    // Code() {
    //   let code = this.codeNum.join("");
    //   return code.replace(/\s+/g, "");
    // },
    codeLength() {
      return this.codeNum.length;
    },
    codeInput() {
      return document.querySelectorAll(".myInput");
    },
    codeNumDetail() {
      return JSON.parse(JSON.stringify(this.codeNum));
    },
    isWindowFocus() {
      return !document.hidden;
    },
    userInfoDetail() {
      return JSON.parse(localStorage.userInfo);
    },
  },
  data() {
    return {
      accessToken: {},
      showChangePass: false,
      showAbout: false,
      wordAvatar: "",
      isWindowChange1: false,
      codeNum: "",
      reGetCodeTime: 60,
      reGetCodeTimer: null,
      windowText1: "",
      windowText2: "",
      isWindowChange2: false,
      changeWindow2Form: {
        phone: "",
        code: "",
      },
      changeWindow2FormValidate: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            required: true,
            pattern: /^[0-9]{6}$/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
      },
      getCodeTime: 60,
      getCodeTimer: null,
      isSave: false,
      passwordOld: "",
      passwordNew: {
        one: "",
        two: "",
      },
      isShowPassword: false,
      // 修改密码第N步
      passwordChangeStep: 1,
      // 消息提示
      showMsgTip: false,
      showMsgNum: "",
      showFocus: true,
      changePhoneForm: {
        msgCode: "",
        oldPhone: "",
        newPhone: "",
      },
      themeForm: {},
      isPhoneTest: false,
      errMessage: "",
      phoneNum: "",
    };
  },
  methods: {
    isError(v) {
      this.$Message.warning({
        content: v,
        duration: 3,
      });
    },
    // 重置密码
    resetPassWord() {
      this.passwordChangeStep = 4;
      this.phoneChange();
    },
    getInfo() {
      getAllThemeSetting().then((res) => {
        if (res.success) {
          if (res.result.length > 0) {
            this.themeForm = res.result[0];
            // 更新信息
            this.$store.commit("setNavTheme", this.themeForm.topSetting);
            this.$store.commit("setMenuTheme", this.themeForm.leftSetting);
            this.$store.commit("setLogo", this.themeForm.logoUrl);
            this.$store.commit("setSysName", this.themeForm.systemName);
            this.$store.commit("setFontSize", this.themeForm.fontSize);
            this.$store.commit("setShowTags", this.themeForm.showTags);
            this.$store.commit("setFirstUrl", this.themeForm.firstUrl);
          } else {
            localStorage.removeItem("theme");
          }
        }
      });
    },
    isFocus(e) {
      if (e.target._prevClass == "showCode") {
        this.showFocus = true;
      } else {
        this.showFocus = false;
      }
    },
    codeFocus(e) {
      if (e.target._prevClass == "showCode") {
        let focus = document.getElementsByClassName("myInput");
        focus[0].focus();
      }
    },
    // data数据初始化
    dataEmpty() {
      this.codeNum = "";
      this.windowText1 = "";
      this.windowText2 = "";
      this.isWindowChange1 = false;
      this.isWindowChange2 = false;
      this.changeWindow2Form = {
        phone: "",
        code: "",
      };
      this.passwordOld = "";
      this.passwordOldShow = "";
      this.passwordNew = {
        one: "",
        two: "",
      };
      this.isShowPassword = false;
      this.passwordChangeStep = 1;
      this.isPhoneTest = false;
    },
    // 修改密码
    changePassword(v) {
      if (v == 2) {
        checkOldPassword({
          userId: this.userId,
          password: this.passwordOld,
        }).then((res) => {
          if (res.result) {
            this.passwordChangeStep = 2;
            this.passwordOld = "";
          } else if (res.message == "密码错误次数超过5次, 60分钟后再试") {
            this.showMsgNum = 1;
            this.showMsgTip = true;
            this.errMessage = res.message;
            // this.$Message.warning("密码验证错误");
          } else {
            this.isError(res.message);
          }
        });
      } else if (v == 3) {
        if (this.passwordNew.one == "" || this.passwordNew.two == "") return;
        if (this.passwordNew.one != this.passwordNew.two) {
          this.$Message.warning("两次密码输入不一致,请重新输入");
          return;
        }
        let reg = /^(?![^a-zA-Z]+$)(?!\D+$).{6,12}$/;
        if (!reg.test(this.passwordNew.one)) {
          this.$Message.warning("密码不符合要求");
          return;
        } else {
          modifyPassword({
            userId: this.userId,
            password: this.passwordNew.two,
          }).then((r) => {
            if (r.result) {
              this.isWindowChange1 = false;
              this.showMsgNum = 2;
              this.showMsgTip = true;
              this.dataEmpty();
            }
          });
        }
      }
    },
    // 发送验证码
    sendMessageCode(v, timer) {
      if (timer == "getCodeTimer") {
        if (this.getCodeTimer !== null) return;
        sendMessageCode({ phone: v }).then((res) => {});
      } else {
        if (this.reGetCodeTimer !== null) return;
        sendMessageCode({ phone: v }).then((res) => {});
      }
    },
    // 获取手机验证码
    getPhoneNum(v) {
      if (v == "old") {
        this.sendMessageCode(this.phoneNum);
        if (this.reGetCodeTimer == null) {
          this.reGetCodeTime--;
          this.reGetCodeTimer = setInterval(() => {
            this.reGetCodeTime--;
            if (this.reGetCodeTime == 0) {
              clearInterval(this.reGetCodeTimer);
              this.reGetCodeTimer = null;
              this.reGetCodeTime = 60;
            }
          }, 1000);
        }
      } else {
        if (
          this.getCodeTimer == null &&
          this.changeWindow2Form.phone.length == 11
        ) {
          this.sendMessageCode(this.changeWindow2Form.phone, "getCodeTimer");
          this.getCodeTime--;
          this.getCodeTimer = setInterval(() => {
            this.getCodeTime--;
            if (this.getCodeTime == 0) {
              clearInterval(this.getCodeTimer);
              this.getCodeTimer = null;
              this.getCodeTime = 60;
            }
          }, 1000);
        }
      }
    },
    // 保存手机号
    savePhoneNum() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.changePhoneForm.newPhone = this.changeWindow2Form.phone;
          this.changePhoneForm.msgCode = this.changeWindow2Form.code;
          modifyPhone(this.changePhoneForm).then((res) => {
            if (res.result) {
              this.isWindowChange2 = false;
              this.showMsgNum = 3;
              let obj = this.userInfoDetail;
              obj.mobile = this.changeWindow2Form.phone;
              this.phoneNum = this.changeWindow2Form.phone;
              localStorage.setItem("userInfo", JSON.stringify(obj));
              this.showMsgTip = true;
              this.dataEmpty();
            } else if (res.code == -4) {
              this.$Message.warning(res.message);
            } else {
              this.$Message.warning("验证码错误");
            }
          });
          // if (
          //   this.changeWindow2Form.phone == "13232530829" &&
          //   this.changeWindow2Form.code == "123123"
          // ) {
          //   this.isWindowChange2 = false;
          //   this.showMsgNum = 3;
          //   this.showMsgTip = true;
          //   this.dataEmpty();
          // } else {
          //   this.$Message.warning("验证码错误");
          // }
        }
      });
    },
    checkMessageCode(v) {
      checkMessageCode({
        phone: this.phoneNum,
        code: v,
        deviceType: "pc",
      }).then((res) => {
        if (res.result) {
          if (this.passwordChangeStep == 1) {
            this.$Message.success("验证成功");
            this.isWindowChange1 = false;
            this.windowText2 = "输入新手机号";
            this.isWindowChange2 = true;
            this.changePhoneForm.oldPhone = this.phoneNum;
          } else if (this.passwordChangeStep == 3) {
            modifyPassword({
              userId: this.userId,
              password: this.passwordNew.two,
            }).then((r) => {
              if (r.result) {
                this.isWindowChange1 = false;
                this.showMsgNum = 2;
                this.showMsgTip = true;
                this.dataEmpty();
              }
            });
          } else if (this.passwordChangeStep == 4) {
            this.isWindowChange1 = false;
            this.passwordChangeStep = 2;
            this.passwordOld = "";
            this.showChangePass = true;
            this.isWindowChange2 = true;
            this.isPhoneTest = true;
          }
        } else if (res.message == "验证码错误次数超过5次, 60分钟后再试") {
          this.showMsgNum = 1;
          this.showMsgTip = true;
          this.errMessage = res.message;
        } else {
          this.$Message.warning("验证码错误");
        }
      });
    },
    // 更换手机号
    phoneChange() {
      this.windowText1 = "身份验证";
      this.showChangePass = false;
      this.isWindowChange1 = true;
      this.codeNum = "";
      this.$nextTick(() => {
        var txts = document.querySelectorAll(".myInput");
        txts[0].focus();
        this.getPhoneNum("old");
      });
    },
    // 获取名称的第一个字
    getWordName() {
      let arr = this.$store.state.user.nickname.split("");
      this.wordAvatar = arr[0];
    },
    init() {
      this.accessToken = {
        accessToken: this.getStore("accessToken"),
      };
    },
    handleClickUserDropdown(name) {
      if (name == "ownSpace") {
        util.openNewPage(this, "ownspace_index");
        this.$router.push({
          name: "ownspace_index",
        });
      } else if (name == "changePass") {
        this.showChangePass = true;
        this.windowText2 = "输入密码";
        this.isWindowChange2 = true;
      } else if (name == "showAbout") {
        this.showAbout = true;
      } else if (name == "loginout") {
        // 退出登录
        this.$store.commit("setLoading", true);
        getOtherSet().then((res) => {
          this.$store.commit("setLoading", false);
          if (res.result) {
            let domain = res.result.ssoDomain;
            Cookies.set("accessToken", "", {
              domain: domain,
              expires: 7,
            });
          }
          this.$store.commit("logout", this);
          this.setStore("accessToken", "");
          // 强制刷新页面 重新加载router
          location.reload();
        });
      }
    },
  },
  mounted() {
    this.phoneNum = JSON.parse(localStorage.userInfo).mobile;
    this.init();
    this.getWordName();
    this.getInfo();
  },
  watch: {
    changeWindow2Form: {
      handler(v) {
        let arr = Object.keys(v);
        if (arr.some((item) => v[item] == "")) {
          this.isSave = false;
        } else {
          this.isSave = true;
        }
      },
      deep: true,
    },
    codeNum(newValue, oldValue) {
      if (
        !/^[0-9]+$/.test(newValue[newValue.length - 1]) &&
        newValue.length > oldValue.length
      ) {
        this.codeNum = oldValue;
      } else if (
        /^[0-9]+$/.test(newValue[newValue.length - 1]) &&
        newValue.length == 6
      ) {
        this.checkMessageCode(this.codeNum);
      }
    },
    isWindowFocus(v) {
      console.log(v, 111);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .windowChange1 .ivu-modal {
  position: relative;
  height: 270px;
  .ivu-modal-content {
    height: 100%;
    .ivu-modal-header {
      padding-bottom: 0;
      border-bottom: 1px solid transparent;
    }
    .ivu-modal-header-inner {
      height: 40px;
      line-height: 30px;
      text-align: left;
      font-size: 18px;
      font-weight: 700;
    }

    .text span {
      padding: 0 4px;
      font-weight: 700;
      font-size: 16px;
    }
    .myInput {
      position: absolute;
      top: -100%;
      color: transparent;
      border: transparent;
      outline: none;
    }
    .codeNum {
      display: flex;
      margin: 20px 0;
      .showCode {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        line-height: 36px;
        padding: 0;
        text-align: center;
        border: #ccc 1px solid;
        border-radius: 2px;
        position: relative;
        .focus {
          background: #000;
          position: absolute;
          margin-top: 50%;
          margin-left: 34%;
          transform: translate(-50%, -50%);
          height: 16px;
          width: 2px;
          animation: 1s focusLine linear forwards infinite;
        }
        @keyframes focusLine {
          0% {
            visibility: inherit;
          }
          25% {
            visibility: hidden;
          }
          75% {
            visibility: hidden;
          }
          100% {
            visibility: inherit;
          }
        }
      }
      // .ivu-input-number {
      //   width: 36px;
      //   height: 36px;
      //   margin-right: 20px;
      //   padding: 0;
      //   .ivu-input-number-handler-wrap {
      //     display: none;
      //   }
      //   .ivu-input-number-input {
      //     height: 36px;
      //     border-radius: 0;
      //     text-align: center;
      //     font-size: 20px;
      //   }
      // }
    }
    .ivu-modal-footer {
      display: none;
    }
  }
}
/deep/ .windowChange2 .ivu-modal {
  position: relative;
  height: 230px;
  .btn_no {
    color: #fff;
    background: #d6e4fb;
    cursor: not-allowed;
  }
  .btn_ok {
    color: #fff;
    background: #307aea;
  }
  .ivu-modal-content {
    height: 100%;
    .ivu-modal-header {
      padding-bottom: 0;
      border-bottom: 1px solid transparent;
    }
    .ivu-modal-header-inner {
      height: 40px;
      line-height: 30px;
      text-align: left;
      font-size: 18px;
      font-weight: 700;
    }
    .ivu-modal-body {
      padding: 0 16px;
      .ivu-input {
        height: 36px;
      }
      .ivu-input-icon {
        height: 36px;
        line-height: 36px;
        font-size: 20px;
        cursor: pointer;
      }
      .ivu-form-item-content {
        display: flex;
        height: 36px;
        input {
          height: 36px;
        }
      }
    }
  }
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #307aea;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-weight: 700;
  margin-top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  margin-right: 20px;
}

.myDropdown {
  padding: 10px;
  .ivu-dropdown-item {
    display: flex;
    padding: 0;
    margin: 0;
    color: #000;
    margin-bottom: 10px;
    .avatar {
      margin: 0;
      margin-right: 10px;
      transform: translateY(0);
    }
  }
  .msg.ivu-dropdown-item {
    position: relative;
    margin-bottom: 24px;
    .name {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      .personName1 {
        display: flex;
        align-items: center;
        & > div:nth-child(1) {
          font-size: 16px;
          font-weight: 700;
        }
        & > div:nth-child(2) {
          color: #999;
          border: 1px solid #999;
          font-size: 12px;
          margin-left: 10px;
        }
      }
      .personName2 {
        display: flex;
        align-items: center;
        & > div:nth-child(1) {
          font-size: 16px;
          font-weight: 700;
        }
        & > div:nth-child(2) {
          color: #307aea;
          border: 1px solid #307aea;
          font-size: 12px;
          margin-left: 10px;
        }
      }
    }
  }
  .phoneNum {
    align-items: center;
    .edit {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      background: #f4f4f4;
      margin-left: 10px;
      cursor: pointer;
      line-height: 16px;
      text-align: center;
    }
  }
}

/deep/ .showMsgTip .ivu-modal {
  height: 272px;
  .ivu-modal-content {
    height: 100%;
    .ivu-modal-body {
      position: relative;
      .imgBox {
        position: relative;
        width: 120px;
        height: 120px;
        margin-top: 20px;
        margin-left: 50%;
        transform: translateX(-50%);
      }
      .img1 {
        background: url("./assets/more_error.png") no-repeat 100% 100%;
      }
      .img2 {
        background: url("./assets/passwordSuccess.png") no-repeat 100% 100%;
      }
      .img3 {
        background: url("./assets/phoneSuccess.png") no-repeat 100% 100%;
      }
      .text1,
      .text2 {
        text-align: center;
      }
      .text1 {
        font-size: 18px;
        font-weight: 700;
        margin-top: 20px;
        color: #000;
      }
      .text2 {
        font-size: 14px;
        color: #ccc;
        margin-top: 10px;
      }
    }
  }
}
</style>